import React from 'react';
import { Locale } from '../locale/types';
import en_US from '../locale/en_US';

export default React.createContext<Locale>(en_US);
